var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.807,
    height: 8.002,
    viewBox: "0 0 4.807 8.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_29654",
    "data-name": "Path 29654",
    d: "M0,4,4,0l.806.806L1.617,4,4.807,7.2,4,8Z",
    fill: "#034ea2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalArrow);
export default __webpack_public_path__ + "static/media/horizontalArrow.0d8b0ab87dea52decf702974a623d4bf.svg";
export { ForwardRef as ReactComponent };